import BigSecurityCrime from "../../../assets/images/icons/controlRisksIncidents/security/big/Crime.svg";
import BigSecurityWar from "../../../assets/images/icons/controlRisksIncidents/security/big/War.svg";
import BigSecurityUnrest from "../../../assets/images/icons/controlRisksIncidents/security/big/Unrest.svg";
import BigSecurityTerrorism from "../../../assets/images/icons/controlRisksIncidents/security/big/Terrorism.svg";

import BigSecurityCrimeWhite from "../../../assets/images/icons/controlRisksIncidents/security/big/Crime-white.svg";
import BigSecurityWarWhite from "../../../assets/images/icons/controlRisksIncidents/security/big/War-white.svg";
import BigSecurityUnrestWhite from "../../../assets/images/icons/controlRisksIncidents/security/big/Unrest-white.svg";
import BigSecurityTerrorismWhite from "../../../assets/images/icons/controlRisksIncidents/security/big/Terrorism-white.svg";

import MapSecurityCrime from "../../../assets/images/icons/controlRisksIncidents/security/map/Crime.svg";
import MapSecurityWar from "../../../assets/images/icons/controlRisksIncidents/security/map/War.svg";
import MapSecurityUnrest from "../../../assets/images/icons/controlRisksIncidents/security/map/Unrest.svg";
import MapSecurityTerrorism from "../../../assets/images/icons/controlRisksIncidents/security/map/Terrorism.svg";

export default [
  {
    Id: 1,
    Name: "Unrest",
    Discriminator: "SecurityCategory",
    Icons: {
      White: BigSecurityUnrestWhite,
      Big: BigSecurityUnrest,
      Map: MapSecurityUnrest,
    },
  },
  {
    Id: 2,
    Name: "Terrorism",
    Discriminator: "SecurityCategory",
    Icons: {
      White: BigSecurityTerrorismWhite,
      Big: BigSecurityTerrorism,
      Map: MapSecurityTerrorism,
    },
  },
  {
    Id: 3,
    Name: "War",
    Discriminator: "SecurityCategory",
    Icons: {
      White: BigSecurityWarWhite,
      Big: BigSecurityWar,
      Map: MapSecurityWar,
    },
  },
  {
    Id: 45,
    Name: "Crime",
    Discriminator: "SecurityCategory",
    Icons: {
      White: BigSecurityCrimeWhite,
      Big: BigSecurityCrime,
      Map: MapSecurityCrime,
    },
  },
];
